import { isValueSymbol } from '../types/typeGuards'
import { NonValueSymbol, SymbolModel, ValueSymbol } from './SymbolModel'
/**
 * Transitioning from HAW to base game symbols are both ValueSymbols and FeatureValueSymbols, they should just be value symbols and blanks
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */

/**
 * Remove cash property from symbols so they are just value or non value symbols
 * @param symbols symbols to cover
 * @returns reels as ValueSymbols or NonValueSymbols
 */
export function covertToValueSymbols(symbols: SymbolModel[][]): (ValueSymbol | NonValueSymbol)[][] {
    return symbols.map((r) =>
        r.map((s) => {
            if (isValueSymbol(s)) {
                return { id: s.id, timesStake: s.timesStake }
            } else {
                return { id: s.id } as NonValueSymbol
            }
        }),
    )
}
